import { useState } from 'react';
import useOperations from '../subirArchivo/SubirArchivoFunction';

const useVoluntarioPDF = () => {
    const [mostrarPDF, setMostrarPDF] = useState(false);
    /**
     * @function cerrarPopUpPdf Cierra el pop-up del PDF
     */
    const cerrarPopUpPdf = () => {
        setMostrarPDF(false);
    };

    /**
     * @function abrirPopUpPdf Abre el pop-up del PDF
     */
    const abrirPopUpPdf = () => {
        setMostrarPDF(true);
    };

    const [mostrarTexto, setMostrarTexto] = useState(false);
    const mostrarTextoEntero = () => setMostrarTexto(!mostrarTexto);
    const { cortarTexto, updateFormat, isPhoneVersion } = useOperations();
    return { isPhoneVersion, updateFormat, mostrarPDF, cerrarPopUpPdf, abrirPopUpPdf, mostrarTextoEntero, mostrarTexto,  cortarTexto };

};

export default useVoluntarioPDF;